export default "__VITE_ASSET__EG1mY9G___"